<template>
	<div class="content">
		<Header />
		<Banner :src="src" />
		<!-- produvct_banner -->
			<div class="solution_content">
				<h2>{{title[0].name}}</h2>
				<div class="photo">
					<img :src="solution[0].bd_coverpicturecn" alt="" />
					<div class="detailBtn" @click="goSolutionOne">
						<p>查看详情</p>
					</div>
				</div>
				<ul class="ullist">
					<li v-for="item in listOne" :key="item.id">
						<router-link :to="`/solution/profile/${item.id}`">{{ item.name }}</router-link>
					</li>
				</ul>
			</div>
			<div class="solution_content" style="padding-bottom:50px">
				<h2>{{title[1].name}}</h2>
				<div class="photo">
					<img :src="solution[1].bd_coverpicturecn" alt="" />
					<div class="detailBtn" @click="goSolutionTwo">
						<p>查看详情</p>
					</div>
				</div>
				<ul>
					<li v-for="item in listTwo" :key="item.id">
						<router-link :to="`/solution/profile/${item.id}`">{{item.name}}</router-link>
					</li>
				</ul>
			</div>
			<div class="solution_content">
				<h2>{{title[2].name}}</h2>
				<div class="photo">
					<img :src="solution[2].bd_coverpicturecn" alt="" />
					<div class="detailBtn" @click="goSolutionThree">
						<p>查看详情</p>
					</div>
				</div>
				<ul class="ullist">
					<li v-for="item in listThree" :key="item.id">
						<router-link :to="`/solution/profile/${item.id}`">{{ item.name }}</router-link>
					</li>
				</ul>
			</div>
			<div class="solution_content">
				<h2>{{title[3].name}}</h2>
				<div class="photo">
					<img :src="solution[3].bd_coverpicturecn" alt="" />
					<div class="detailBtn" @click="goSolutionFour">
						<p>查看详情</p>
					</div>
				</div>
				<ul>
					<li v-for="item in listFour" :key="item.id">
						<router-link :to="`/solution/profile/${item.id}`">{{ item.name }}</router-link>
					</li>
				</ul>
			</div>
		<!-- product_center -->
		<Footer />
	</div>
</template>

<script>
import Header from '../../components/Header.vue'
import Banner from '../../components/Banner.vue'
import Footer from '../../components/Footer.vue'
import Axios from 'axios'
import Vue from 'vue'
Vue.config.warnHandler = function(msg, vm, trace) {
    console.log(`Warn: ${msg}\nTrace: ${trace}`);
  }
export default {
	components: { Header, Banner, Footer },
	data() {
		return {
			src: '',
			title:[],
			listOne:[],
			listTwo:[],
			listThree:[],
			listFour:[],
			idOne:[],
			idTwo:[],
			idThree:[],
			idFour:[],
			solution:[]
		}
	},
	mounted() {
		Axios({
			url: '/apiv2/sconfig/getlist',
			data: {},
			method: 'GET',
		}).then((res) => {
       let common=res.data.data.rows
			for (var i = 0; i < common.length; i++) {
				if (
					common[i].sc_key.slice(0, 22) == 'SOLUTION_CENTER_BANNER'
				) {
					this.src = common[i].sc_value
				}
			}
        })
			
		Axios({
			url:'/apiv2/bdoctree/gettree?bdContenttype=解决方案',
			data:{},
			method:'GET',
		}).then((res)=>{
			this.idOne=res.data.data[0].id
			this.idTwo=res.data.data[1].id
			this.idThree=res.data.data[2].id
			this.idFour=res.data.data[3].id
			this.title=res.data.data
			this.listOne=res.data.data[0].child
			this.listTwo=res.data.data[1].child
			this.listThree=res.data.data[2].child
			this.listFour=res.data.data[3].child
		})
		Axios({
		url: '/apiv2/bdoctreecontent/getlist?bdContenttype=解决方案',
		data: {},
		method: 'GET',
	}).then((res) => {
		for(var m=0;m<res.data.data.rows.length;m++){
			if(res.data.data.rows[m].bd_treenodepid==''){
				res.data.data.rows[m].bd_coverpicturecn=res.data.data.rows[m].bd_coverpicture2cn
				this.solution.push(res.data.data.rows[m])
				}
			}
		})
	},
	methods:{
		goSolutionOne(){
			this.$router.push('/solution/solutiondetail/'+this.idOne)
		},
		goSolutionTwo(){
			this.$router.push('/solution/solutiondetail/'+this.idTwo)
		},
		goSolutionThree(){
			this.$router.push('/solution/solutiondetail/'+this.idThree)
		},
		goSolutionFour(){
			this.$router.push('/solution/solutiondetail/'+this.idFour)
		}
	}
}
</script>

<style lang="scss" scoped>
@media (min-width: 1200px) {
	@import '../../style/base.scss';
	.pro_banner {
		// height: 600px;
		img {
			display: block;
			width: 100%;
			height: 100%;
		}
	}
	.solution_content {
		border: 1px solid #dbdada;
		width: 80%;
		margin: 0px auto;
		margin-top: 50px;
		margin-bottom:150px;
		box-shadow: 4px 4px 4px 0 #696969;
		padding-bottom:30px;
		background: #f5f5f5;
		h2 {
			text-align: center;
			font-size: 30px;
			font-weight: normal;
			line-height: 38px;
			margin:	30px 0 30px;
			color: #DBB866;
		}
		.photo {
			width: 100%;
			height: 500px;
			img {
				display: block;
				width:100%;
				height: 100%;
				object-fit: cover;
				transition: all 0.4s ease;
			}
			.detailBtn{
				display: none;
				width: 100%;
				height: 500px;
				font-size: 16px;
				line-height: 50px;
				text-align: center;
				background: rgba($color: #000000, $alpha: 0.5);
				position: relative;
				top: -500px;
				p{
					cursor: pointer;
					width: 120px;
					height: 40px;
					font-size: 14px;
					line-height: 40px;
					color:#ccc;
					border: 1px solid #ccc;
					position: absolute;
					top: 0;
					left: 0;
					bottom: 0;
					right: 0;
					margin: auto;
				}
				p:hover{
					color: #fff;
					border: 1px solid #fff;
				}
			}
		}
		.photo:hover{
			.detailBtn{
				display: block;
			}
		}
		ul {
			width: 100%;
			padding-left: 80px;
			// margin: 20px auto;
			// display: flex;
			// justify-content: space-between;
			// flex-wrap: wrap;
			li {
				width: 30%;
				margin-top: 20px;
				background: url('~@/assets/imgs/right.png') no-repeat left center;
				padding-left: 20px;
				cursor: pointer;
				display: inline-block;
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;
				word-break: break-all;
				a{	
					text-decoration: none;
					color: #333333 !important;
				}
			}
			li:hover{
				a{
					color: #DBB866 !important;
				}
			}
		}
	}
}
 
@media (max-width: 1199px) {
	@import '../../style/mb.scss';
	.pro_banner {
		// height: 600px;
		padding: rm(20);
		img {
			display: block;
			width: 100%;
			height: 100%;
		}
	}
	.solution_content {
		h2 {
			text-align: center;
			font-size: rm(26);
			font-weight: normal;
			line-height: rm(45);
			margin: 0 0 rm(10);
		}
		.photo {
			// height: 500px;
			padding: 0 rm(20);
			img {
				display: block;
				width: 100%;
				// height: 100%;
			}
		}
		ul {
			margin: rm(15) rm(20);
			width:100%;
			// display: flex;
			// justify-content: space-between;
			// flex-wrap: wrap;
			li {
				width: 80%;
				margin: rm(10) 0;
				border-bottom: rm(1) solid #ccc;
				background: url('~@/assets/imgs/right.png') no-repeat left center;
				padding-left: rm(30);
				padding-bottom: rm(10);
				display: inline-block;
				a {
					color: #333;
				}
			}
		}
	}
}
</style>